import React, { useState } from "react";
import { postDonationEntry } from "../services/apiservice"; // Import API function
import "./Donation.scss";
import donationImage from "../assets/images/qrcbackground.png";
import successGif from "../assets/images/namastehands.jpg"; // Import your success GIF

const RefundPage = () => {
 
  

  return (
    <div className="donation-container">
      
      <div className="termscontent">
        <div className="header1">
          <h1>Refund and Cancellation policy</h1>
          <p>&nbsp;</p>
          <p style={{textAlign:"left"}}> 
          This refund and cancellation policy outlines how you can cancel or seek a refund for a product / service
          that you have purchased through the Platform. Under this policy:
          </p>
          <p>&nbsp;</p>
          <p style={{textAlign:"left"}}> 
            1. Cancellations will only be considered if the request is made <b>2 days</b> of placing the order. However,
cancellation requests may not be entertained if the orders have been communicated to such sellers /
merchant(s) listed on the Platform and they have initiated the process of shipping them, or the
product is out for delivery. In such an event, you may choose to reject the product at the doorstep
          </p>
          <p>&nbsp;</p>
          <p style={{textAlign:"left"}}> 
          2. <b>Shri Datta Mandir Sansthan Ruibhar</b> does not accept cancellation requests for perishable items
like flowers, eatables, etc. However, the refund / replacement can be made if the user establishes
that the quality of the product delivered is not good.
          </p>
          <p>&nbsp;</p>
          <p style={{textAlign:"left"}}> 
          3. In case of receipt of damaged or defective items, please report to our customer service team. The
request would be entertained once the seller/ merchant listed on the Platform, has checked and
determined the same at its own end. This should be reported within <b>2 days</b> of receipt of products.
In case you feel that the product received is not as shown on the site or as per your expectations,
you must bring it to the notice of our customer service within <b>2 days</b> of receiving the product. The
customer service team after looking into your complaint will take an appropriate decision
          </p>
          <p>&nbsp;</p>
          <p style={{textAlign:"left"}}> 
          4. In case of complaints regarding the products that come with a warranty from the manufacturers,
          please refer the issue to them
          </p>
          <p>&nbsp;</p>
          <p style={{textAlign:"left"}}> 
          5. In case of any refunds approved by <b>Shri Datta Mandir Sansthan Ruibhar</b>, it will take <b>5 days</b> for
          the refund to be processed to you.

          </p>
          <p>&nbsp;</p>
        </div>
      </div>
    </div>
  );
};

export default RefundPage;
